import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-bootstrap';

const clientBasePath = process.env.REACT_APP_CLIENT_BASE_PATH; // set via webpack build

const PageDoesNotExist = ({ location }) => (
    <Grid>
        <h1>Page Does Not Exist</h1>
        <p>The requested page '{location.pathname}' does not exist</p>
        <p>
            <a href={clientBasePath}>Go to home page.</a>
        </p>
    </Grid>
);

PageDoesNotExist.propTypes = {
    location: PropTypes.object
};

PageDoesNotExist.defaultProps = {
    location: {}
};

export default PageDoesNotExist;



// WEBPACK FOOTER //
// ./src/components/core/404.js